const ITEMS = [
    { name: "CALDERA", meta: "ECOSYSTEM // ROLLUPS" },
    { name: "SOMNIA", meta: "ECOSYSTEM // L1" },
    { name: "THEORIQ", meta: "ECOSYSTEM // AGENT NETWORK" },
    { name: "UNION", meta: "ECOSYSTEM // ZK BRIDGE" },
    { name: "IRYS", meta: "ECOSYSTEM // DATA LAYER" },
    { name: "RAYLS", meta: "ECOSYSTEM // RWA" },
    { name: null, meta: "ZK PROOF-OF-HUMANITY" },
    { name: null, meta: "SOC2 · GDPR · MICA" },
    { name: null, meta: "SUID MAINNET LIVE" },
];

const Row = ({ ariaHidden }) => (
    <div aria-hidden={ariaHidden || undefined} className="flex shrink-0 items-center">
        {ITEMS.map((item, i) => (
            <div key={i} className="flex items-center gap-3 px-8 sm:px-12">
                {item.name ? (
                    <div className="flex items-baseline gap-3">
                        <span className="font-display text-lg font-bold tracking-wide text-slate-200 sm:text-xl">
                            {item.name}
                        </span>
                        <span className="hidden font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 sm:inline">
                            {item.meta}
                        </span>
                    </div>
                ) : (
                    <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-neon-cyan/70">
                        {item.meta}
                    </span>
                )}
                <span className="ml-8 h-1.5 w-1.5 rotate-45 bg-neon-cyan/40" />
            </div>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <section className="overflow-hidden border-y border-white/5 bg-[#05070D] py-8" data-testid="ecosystem-marquee">
            <div className="animate-marquee flex w-max">
                <Row />
                <Row ariaHidden />
            </div>
        </section>
    );
}